export function collectUserQuestionPayload(form) {
  const pairs = []

  form.querySelectorAll(".ask-user-question-field").forEach(field => {
    const id = field.dataset.fieldId
    const type = field.dataset.fieldType
    const values = userQuestionFieldValues(field, type)

    if (type === "checkbox") {
      values.forEach(value => {
        pairs.push([`answers[${id}][]`, value])
      })
    } else {
      pairs.push([`answers[${id}]`, values[0] || ""])
    }
  })

  return pairs
}

export function collectUserQuestionSummaryFields(form) {
  return Array.from(form.querySelectorAll(".ask-user-question-field")).map(field => {
    const label = field.querySelector(".ask-user-question-label")?.textContent || field.dataset.fieldId
    const type = field.dataset.fieldType
    const values = userQuestionFieldValues(field, type)
    return { label, values }
  })
}

function userQuestionFieldValues(field, type) {
  if (type === "checkbox") {
    return Array.from(field.querySelectorAll("input:checked")).map(input => input.value)
  }

  if (type === "radio") {
    return [field.querySelector("input:checked")?.value || ""]
  }

  return [field.querySelector("input")?.value || ""]
}
